import { makeStyles } from '@material-ui/core';
import themeStyle from 'styles/theme';
import colors from 'styles/colors';

const useTimeLineStyles = makeStyles(theme => ({
  paper: {
    position: 'relative',
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    height: 'fit-content',
    border: `1px solid ${colors.gray[200]}`,
    borderRadius: 12,
    boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)'
  },
  paperContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(2)
  },
  timelineContent: {
    margin: 0,
    padding: 0
  },
  textArea: {
    width: '100%',
    minWidth: '100%',
    maxWidth: 'fit-content',
    border: 'none',
    fontFamily: themeStyle.typography.fontFamily,
    fontSize: theme.spacing(2)
  },
  timelineItem: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  timelineAssetContent: {
    width: theme.spacing(22),
    height: theme.spacing(20),
    padding: theme.spacing(0)
  },
  timelineAssetTime: {
    marginTop: theme.spacing(2)
  },
  timelineAssetSection: {
    width: theme.spacing(22),
    height: theme.spacing(14)
  },
  displayContents: {
    display: 'contents'
  },
  paddingRm: {
    margin: 0,
    padding: 0
  },
  actionIcon: {
    cursor: 'pointer'
  },
  assetType: {
    ...themeStyle.typography.smSemibold
  }
}));
export default useTimeLineStyles;
